import { useId } from "react";
import type { IconProps } from "./types";

export default function WholeFoodScoreIcon({ size = 24, color = "currentColor", title, ...svgProps }: IconProps) {
    const maskId = useId();

    return (
        <svg
            viewBox="11.5 9 41 41"
            width={size}
            height={size}
            color={color}
            fill="none"
            role={title ? "img" : undefined}
            aria-hidden={title ? undefined : true}
            aria-label={title}
            xmlns="http://www.w3.org/2000/svg"
            {...svgProps}
        >
            {title ? <title>{title}</title> : null}
            <defs>
                <mask id={maskId} maskUnits="userSpaceOnUse" x="0" y="0" width="64" height="64">
                    <rect width="64" height="64" fill="white" />
                    <path
                        d="m24.2 35.5 5 5 10.6-11"
                        stroke="black"
                        strokeWidth="3.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </mask>
            </defs>
            <path d="M31.5 22.5c0-4.4 2.3-7.8 6.4-9.5" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round" />
            <path
                d="M33.5 18.5c4-4.8 9.1-4.4 12-2.8-2.8 4.5-7.4 5.8-12 2.8Z"
                fill="currentColor"
                opacity=".66"
            />
            <path
                d="M32 24.8c-3.7-4-12.8-3-15.2 5.9-2.3 8.4 4.8 18.6 11.2 18.6 2 0 2.6-1 4-1s2 1 4 1c6.4 0 13.5-10.2 11.2-18.6-2.4-8.9-11.5-9.9-15.2-5.9Z"
                fill="currentColor"
                mask={`url(#${maskId})`}
            />
        </svg>
    );
}
